import {
    PreloadedQuery,
    useLazyLoadQuery,
    usePreloadedQuery
} from "react-relay";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { agileTutorialOneQuery } from "@/__generated_contentful__/agileTutorialOneQuery.graphql";
import { agileTutorialTwoQuery } from "@/__generated_contentful__/agileTutorialTwoQuery.graphql";
import { SiteSelectorContextProvider } from "@/components/site-selector-modal";
import { SitesContextProvider } from "@/components/sites-provider";
import {
    AgileTutorialQueryData,
    AgileTutorialOneQuery,
    AgileTutorialTwoQuery,
    getAgileTutorialQueryVars,
    shapeAgileHubTutorialContentfulResponse
} from "@/contentful/graphql/agile-tutorial";
import AgileTutorialPageTemplate from "@/templates/agile-hub/agile-tutorial-page/src";
import { AgileTutorialProvider } from "@/templates/agile-hub/src/agile-tutorial.provider";
import { AgileTutorial } from "@/templates/agile-hub/tutorial-types";

export type AgileTutorialPageProps = {
    agileTutorial: AgileTutorial | null;
    queryRef: PreloadedQuery<agileTutorialOneQuery>;
    location: Location;
};

export const AgileTutorialPage = ({
    agileTutorial,
    queryRef,
    location
}: AgileTutorialPageProps) => {
    const dataPartOne = usePreloadedQuery<agileTutorialOneQuery>(
        AgileTutorialOneQuery,
        queryRef
    );
    const dataPartTwo = useLazyLoadQuery<agileTutorialTwoQuery>(
        AgileTutorialTwoQuery,
        getAgileTutorialQueryVars(location)
    );

    const combinedData = {
        tutorialDetailsCollection: {
            items: [
                {
                    ...dataPartOne.tutorialDetailsCollection?.items[0],
                    ...dataPartTwo.tutorialDetailsCollection?.items[0]
                }
            ]
        }
    } as AgileTutorialQueryData;
    agileTutorial = shapeAgileHubTutorialContentfulResponse(combinedData);

    return (
        <SitesContextProvider>
            <SiteSelectorContextProvider
                analyticsPrefix="jira-software.ondemand" // TODO: Check if this is correct
                productKey={ProductKeys.JIRA_SOFTWARE}
            >
                <AgileTutorialProvider tutorial={agileTutorial}>
                    <AgileTutorialPageTemplate />
                </AgileTutorialProvider>
            </SiteSelectorContextProvider>
        </SitesContextProvider>
    );
};
